import { Routes } from '@angular/router';

import { loggedInAccessGuard } from '@app/core';
import { semrushGuard } from '@app/core/guards/semrush.guard';
import { redirectToHomeWithSemrushUpgradeOffer } from '@app/integrations/semrush/semrush-upgrade-redirect';
import { Path } from '@app/routing/path';
import { PACKAGE_NAMES } from '@main/services/limit-upgrade/limit-upgrade.types';

export const integrationsPagesRoutes: Routes = [
    {
        path: Path.upgrade,
        canActivate: [semrushGuard, loggedInAccessGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: '/',
            },
            {
                path: 'starter-to-professional',
                redirectTo: redirectToHomeWithSemrushUpgradeOffer,
                data: {
                    upgradeFrom: PACKAGE_NAMES.BASIC,
                    upgradeTo: PACKAGE_NAMES.PROFESSIONAL,
                },
            },
            {
                path: 'starter-to-team',
                redirectTo: redirectToHomeWithSemrushUpgradeOffer,
                data: {
                    upgradeFrom: PACKAGE_NAMES.BASIC,
                    upgradeTo: PACKAGE_NAMES.TEAM,
                },
            },
            {
                path: 'professional-to-team',
                redirectTo: redirectToHomeWithSemrushUpgradeOffer,
                data: {
                    upgradeFrom: PACKAGE_NAMES.PROFESSIONAL,
                    upgradeTo: PACKAGE_NAMES.TEAM,
                },
            },
        ],
    },
];
